import styles from './ContactRelationshipWrapperComponent.module.css';
import { ILayoutComponentProps, LayoutComponent } from '../LayoutComponent';
import { useCallback, useEffect, useState } from 'react';
import { useDependency } from '../../../../contexts/DependencyProvider';
import { GetContactRequest } from '../../../../services/soap/main/requests/GetContactRequest';
import { ListCompanyPersonRelationsRequest } from '../../../../services/soap/main/requests/ListCompanyPersonRelationsRequest';
import { ListFolderOrganizationRequest } from '../../../../services/soap/project/requests/ListFolderOrganizationRequest';
import ContactRelationsDetail from './components/ContactRelationsDetail';
import { ListStatusRequest, ListStatusType } from '../../../../services/soap/project/requests/ListStatusRequest';
import { statusColor } from '../../../../utils/helperUtil';
import { DialogContainer, ToastQueue } from '@adobe/react-spectrum';
import AddNewPerson from '../../../../pages/protected/contacts/component/AddNewPerson';
import AddNewCompany from '../../../../pages/protected/contacts/component/AddNewCompany';
import { DeleteContactRequest } from '../../../../services/soap/main/requests/DeleteContactRequest';
import { ListFormSettingsRequest } from '../../../../services/soap/features/requests/ListFormSettingsRequest';
import { GetFormSettingsRequest } from '../../../../services/soap/features/requests/GetFormSettingsRequest';

export interface IContactRelationWrapperProps extends ILayoutComponentProps {
}

function ContactRelationWrapper({ selectedItem }: IContactRelationWrapperProps) {
  const [contact, setContact] = useState<any | null>(null);
  const [employeesList, setEmployeesList] = useState<any>([]);
  const [isPerson, setIsPerson] = useState(false);
  const [showLoaderDetail, setShowLoaderDetail] = useState(true);
  const [employeeDetail, setEmployeeDetail] = useState<any>(null);
  const [navigationStack, setNavigationStack] = useState<string[]>([]);
  const [showEmployeeDetail, setShowEmployeeDetail] = useState<boolean>(false);
  const { store, mainService,projectService,featureService} = useDependency();
  const [contactStatusList, setContactStatusList] = useState<any>([]);
  const [listOrganizationFolder, setListOrganizationFolder] = useState<any>([]);
  const [isEdit, setIsEdit] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [addFormType, setAddFormType] = useState<string>('');
  const [fieldConfig, setFieldConfig] = useState({});
  const [documents, setDocuments] = useState<Array<{ documentId: string; name: string; description: string; isPrimaryPicture: string }>>();

  useEffect(()=>{
    getFolderStatus();
  },[])

  useEffect(()=>{
    getLayout(undefined,selectedItem?.id)
  },[selectedItem])

  const getAddFormSettings = useCallback(
      async (settingId: string, formType: string) => {
        if (settingId === '0') {
          const resFormSettings = await featureService.listFormSettings(new ListFormSettingsRequest(store.Server, store.SessionId));
          let filteredData = resFormSettings.SETTING.filter((item: any) => item.formId === formType && item.isDefault == '1');
          if (filteredData.length > 0) {
            settingId = filteredData[0].id.toString();
          }
        }
        const response = await featureService.getFormSettings(new GetFormSettingsRequest(store.Server, store.SessionId, settingId));
        if (response?.result === 'OK' && response?.count > 0) {
          const filteredData = response.SETTING[0]?.ITEM?.filter(item => String(item.mandatory) === '1');
          if(filteredData && filteredData.length > 0){
              const processedConfig = filteredData.length > 0 ? filteredData.reduce((acc: any, field: any) => {
                acc[field.itemname] = {
                  visible: field.visibility === '1',
                  required: field.mandatory === '1',
                };
                return acc;
              }, {}):{};
  
              setFieldConfig(processedConfig);
          }else{
            ToastQueue.negative("Form settings are missing",{timeout:300});
          }
        }
      },
      []
    );

  const getFolderStatus = async () => {
      const res = await projectService.listFolderStatus2(new ListStatusRequest(store.Server, store.SessionId, ListStatusType.Folder));
      const statusArray: any = [];
      if (res.result === 'OK' && res.STATUS.length > 0) {
        res?.STATUS.forEach((status: any) => {
          const { id, name, color } = status;
          let colorString = statusColor(color);
          statusArray.push({ id, name, color: colorString });
        });
        setContactStatusList(statusArray);
      }
    };

  function extractSingleObject(data: any): any {
    if (typeof data !== 'object' || data === null) {
      return null; // Invalid input
    }
    const keys = Object.keys(data);
    // If it contains numbered keys, return the first object's value
    if (keys.some(key => !isNaN(Number(key)))) {
      for (const key of keys) {
        if (!isNaN(Number(key))) {
          return data[key]; // Return the first numeric key's value
        }
      }
    }
    return data;
  }
  function extractStructuredData(data: any) {
    if (typeof data !== 'object' || data === null) {
      return {
        mainObject: null,
        documents: [],
        companyInfo: {},
      };
    }

    const mainObject = data['0'] || null;
    const documents: any[] = [];
    let companyInfo: any = {};

    for (const key in data) {
      if (!isNaN(Number(key)) && key !== '0') {
        if (data[key]?.DOCUMENT) {
          documents.push(data[key].DOCUMENT);
        }
      } else if (key === 'COMPANYINFO') {
        companyInfo = data[key];
      }
    }

    return {
      mainObject,
      documents,
      companyInfo,
    };
  }

  const getLayout = async (selectedId: any,folderId?:any) => {
    try {
      const contactResult = await mainService.getContact(new GetContactRequest(store.Server, store.SessionId, undefined, undefined, selectedId,folderId));
      if (contactResult.result === 'OK') {
        let result: any = null;
        let relationFilters = {};
        if (contactResult.PERSON) {
          setIsPerson(true);
          const { mainObject, documents, companyInfo } = extractStructuredData(contactResult.PERSON);
          result = extractSingleObject(contactResult.PERSON);
          setDocuments(documents);
          setContact(result);
          relationFilters = { COL: [{ name: 'contact', type: 'equals', value: result.id }] };
        } else if (contactResult.COMPANY) {
          setIsPerson(false);
          const { mainObject, documents, companyInfo } = extractStructuredData(contactResult.COMPANY);
          result = extractSingleObject(contactResult.COMPANY);
          setDocuments(documents);
          setContact(result);
          relationFilters = { COL: [{ name: 'company', type: 'equals', value: result.id }] };
        } else {
          setIsPerson(false);
          setContact(null);
        }

        var employeesResult = await mainService.listCompanyPersonRelations(
          new ListCompanyPersonRelationsRequest(store.Server, store.SessionId, {
            FILTER: relationFilters,
          })
        );
        if (employeesResult.result == 'OK') {
          setEmployeesList(employeesResult.EMPLOYEE);
        }

        const folders = await projectService.listFolderOrganization(new ListFolderOrganizationRequest(store.Server, store.SessionId, { contactId: result.id }));
        if (result && result.FOLDERS) {
          let folderIds;
          if (!Array.isArray(result.FOLDERS)) {
            folderIds = [result.FOLDERS.FOLDER.id];
          } else {
            folderIds = result?.FOLDERS?.reduce((uniqueIds: Set<string>, folder: any) => {
              const folderId = folder.FOLDER.id;
              uniqueIds.add(folderId);
              return uniqueIds;
            }, new Set<string>());
          }

          if (folderIds) {
            const uniqueFolderIds = Array.from(folderIds);

            const uniqueItems = folders?.ITEM?.reduce((uniqueMap: Map<string, any>, item: any) => {
              if (!uniqueMap.has(item.folderId)) {
                uniqueMap.set(item.folderId, item);
              }
              return uniqueMap;
            }, new Map<string, any>());

            const filteredItems = Array.from(uniqueItems.values()).filter((item: any) => uniqueFolderIds.includes(item.folderId));

            setListOrganizationFolder(filteredItems);
          } else {
            setListOrganizationFolder([]);
          }
        } else {
          setListOrganizationFolder([]);
        }
        return result;
      }
    } catch (err) {
      console.error('getlayout error: ', err);
    } finally {
      setShowLoaderDetail(false);
    }
  };

  const handleEmployeeClick = async (employee: any) => {
    setShowLoaderDetail(true);
    const contactResult = await mainService.getContact(new GetContactRequest(store.Server, store.SessionId, undefined, undefined, employee));
    if (contactResult.result === 'OK') {
      const person = contactResult.PERSON;
      setEmployeeDetail(person);
      if (person.id) {
        let nav = [...navigationStack];
        nav.push(contact.id);
        setNavigationStack(nav);
      }
      getLayout(employee);
      setContact(contact);
      setShowLoaderDetail(false);
    }
  };

  const handleEmployerClick = async (employer: any) => {
    setShowLoaderDetail(true);
    const contactResult = await mainService.getContact(new GetContactRequest(store.Server, store.SessionId, undefined, undefined, employer));
    if (contactResult.result === 'OK') {
      let company = contactResult.COMPANY || contactResult.PERSON;
      if (company.id) {
        let nav = [...navigationStack];
        nav.push(contact.id);
        setNavigationStack(nav);
      }
      setContact(company);
      getLayout(company.id);
      setShowEmployeeDetail(false);
      setShowLoaderDetail(false);
    }
  };

  const handleBack = () => {
    const nav = [...navigationStack];
    if (nav.length > 0) {
      const currentId = nav.pop();
      setNavigationStack(nav);
      getLayout(currentId,undefined);
    }
  };


  const handleEditClick = (data: boolean) => {
    if (data) {
      setIsEdit(data);
      if (isPerson) {
        setAddFormType('person');
        setShowAdd(true);
      } else {
        setAddFormType('company');
        setShowAdd(true);
      }
    }
  };

  const handleAddNewClose = () => {
    setShowAdd(false);
    setIsEdit(false);
    setAddFormType('');
  };

  const refreshDetailView = async (contactId: any) => {
    setShowLoaderDetail(true);
    await getLayout(contactId);
  };

  const handleRefreshAddNewContact = async (contactId: any) => {
    setShowLoaderDetail(true);
    await getLayout(contactId);
  };

  const handleContactDelete = async (data: any) => {
      const deleteContact = await mainService.deleteContact(new DeleteContactRequest(store.Server, store.SessionId, data.id));
      if (deleteContact.result === 'OK') {
        ToastQueue.positive('Contact deleted successfully...', { timeout: 3000 });
      } else {
        ToastQueue.negative(deleteContact.EXCEPTION.message, { timeout: 3000 });
      }
    };

  return (
      <>
      <ContactRelationsDetail
        contact={contact}
        employees={employeesList}
        handleEmployeeClick={handleEmployeeClick}
        isPerson={isPerson}
        handleEmployerClick={handleEmployerClick}
        navigationStack={navigationStack}
        handleBack={handleBack}
        listOrganizationFolder={listOrganizationFolder}
        contactStatusList={contactStatusList}
        handleEditClick={handleEditClick}
        handleContactDelete={handleContactDelete}
      />
      <DialogContainer onDismiss={handleAddNewClose}>
        {showAdd && addFormType === 'person' ? (
          <AddNewPerson
            onCloseModal={handleAddNewClose}
            person={contact}
            isEdit={isEdit}
            employments={employeesList}
            handleEditClick={handleEditClick}
            refreshDetailView={refreshDetailView}
            handleRefreshAddNewContact={handleRefreshAddNewContact}
            fieldConfig={fieldConfig}
            documents={documents}
          />
        ) : (
          showAdd &&
          addFormType === 'company' && (
            <AddNewCompany
              refreshDetailView={refreshDetailView}
              handleRefreshAddNewContact={handleRefreshAddNewContact}
              onCloseModal={handleAddNewClose}
              company={contact}
              isEdit={isEdit}
              employments={employeesList}
              handleEditClick={handleEditClick}
              fieldConfig={fieldConfig}
              documents={documents}
            />
          )
        )}
      </DialogContainer>
</>
  );
}

export const ContactRelationWrapperComponent = LayoutComponent(ContactRelationWrapper);